/**
 * Toggle the search bar for showing search form
 *
 */
export function toggleSearchBar() {
    const searchToggle = document.querySelector("#ig-main-site-header .ig-search-form .search-icon")
    const searchForm = document.querySelector("#ig-main-site-header .ig-search-form .search-form")
    const searchBtn = document.querySelector("#ig-main-site-header .ig-search-form .search-icon-active")

    const mobileSearchToggle = document.querySelector("#ig-main-site-mobile-header .ig-search-form .search-icon")
    const mobileSearchForm = document.querySelector("#ig-main-site-mobile-header .ig-search-form .search-form")
    const mobileSearchBtn = document.querySelector("#ig-main-site-mobile-header .ig-search-form .search-icon-active")

    const searchResultsPage = document.querySelector("body").classList.contains('search-results')
    const clearSearchBtn = document.querySelector("#ig-main-site-mobile-header .ig-search-form .clear-search")
    const searchInput = document.querySelector("#ig-main-site-mobile-header .ig-search-form .search-form .search")

    if (!searchToggle || !mobileSearchToggle) return

    if (searchResultsPage) {
        searchForm.style.display = "flex"
        searchBtn.style.display = "block"
    }

    searchForm.addEventListener("submit", (event) => {
        const input = searchForm.querySelector('.search')
        if (input.value.trim() === '') {
            event.preventDefault();
        }
    })

    mobileSearchForm.addEventListener("submit", (event) => {
        if (searchInput.value.trim() === '') {
            event.preventDefault();
        }
    })

    searchToggle.addEventListener("click", (event) => {
        event.stopPropagation()

        if (searchForm.style.display == "none" || searchForm.style.display == "") {
            searchForm.style.display = "flex"
            searchBtn.style.display = "block"
            searchForm.focus()
        } else {
            searchForm.style.display = "0px"
            searchBtn.style.display = "none"
        }
    })

    mobileSearchToggle.addEventListener("click", (event) => {
        event.stopPropagation()

        if (mobileSearchForm.style.display == "none" || mobileSearchForm.style.display == "") {
            mobileSearchForm.style.display = "flex"
            mobileSearchBtn.style.display = "block"
            mobileSearchToggle.style.display = "none"
            mobileSearchForm.focus()
        } else {
            mobileSearchForm.style.display = "0px"
            mobileSearchBtn.style.display = "none"
        }
    })

    if (clearSearchBtn) {
        clearSearchBtn.addEventListener("click", () => {
            searchInput.value = ""
        })
    }

    document.addEventListener("click", function (event) {
        const isClickInsideForm = searchForm.contains(event.target)
        const isClickOnIcon = searchToggle.isSameNode(event.target)
        const isMobileForm = mobileSearchForm.contains(event.target)
        const isMobileIcon = mobileSearchToggle.isSameNode(event.target)

        if (!isClickInsideForm && !isClickOnIcon && searchForm.style.display !== "none" && !searchResultsPage) {
            searchForm.style.display = "none"
            searchBtn.style.display = "none"
        }

        if (!isMobileForm && !isMobileIcon && mobileSearchForm.style.display !== "none") {
            mobileSearchForm.style.display = "none"
            mobileSearchBtn.style.display = "none"
            mobileSearchToggle.style.display = "flex"
        }
    });

}

export function toggleMobileMenu() {
    const mobileToggle = document.querySelector("#mobile-toggle")
    const mobileHeader = document.querySelector("#ig-main-site-mobile-header")
    const wpadminbar = document.querySelector("#wpadminbar")
    const mobilePanel = document.querySelector("#mobile-menu-panel")
    const topmenubar = document.querySelector(".mobile-wrapper")

    if (!mobileToggle) return

    mobileToggle.addEventListener("click", () => {
        mobileToggle.classList.toggle('opened');
        mobileToggle.setAttribute('aria-expanded', mobileToggle.classList.contains('opened'))
        mobileHeader.classList.toggle("mobile-panel-open")
        document.body.classList.toggle('no-scroll');

        if (mobileHeader.classList.contains("mobile-panel-open")) {

            if (wpadminbar !== null) {
                mobilePanel.style.height = `calc(100vh - 146px`
            } else {
                mobilePanel.style.height = `calc(100dvh - ${topmenubar.clientHeight}px`
            }
        }
    })
}


export function headerScroll() {
    // Select the element to make sticky
    const siteHeader = document.querySelector("#ig-main-site-header")
    const mobileHeader = document.querySelector("#ig-main-site-mobile-header")

    const utilityNav = document.querySelector(".utility-nav-wrapper")
    const wpadminbar = document.querySelector("#wpadminbar")

    if (!siteHeader) return
    // Function to run whenever the window scrolls
    window.onscroll = function () {
        if (window.pageYOffset > 0) {
            // When the scroll position reaches or exceeds the element's initial offset, make it sticky
            siteHeader.style.position = 'fixed'
            utilityNav.classList.add('hidden')
            siteHeader.classList.add('scrolling-nav')

            if (!mobileHeader.classList.contains("mobile-panel-open")) {
                mobileHeader.style.position = 'fixed'
                siteHeader.classList.add('scrolling-nav')
            }

            if (wpadminbar !== null) {
                siteHeader.style.top = '32'
            } else {
                siteHeader.style.top = '0'
            }

        } else {
            // When the scroll position is less than the element's initial offset, make it relative
            siteHeader.style.position = 'relative'
            siteHeader.style.top = ''
            utilityNav.classList.remove('hidden')
            siteHeader.classList.remove('scrolling-nav')

            if (!mobileHeader.classList.contains("mobile-panel-open")) {
                mobileHeader.style.position = 'relative'
            }
        }
    }
}

/**
    * Helper function to check for active class
    *
    * @param {NodeListOf<Element>} targetNode - List of elements using querySelectorAll
    * @returns {boolean}
    */
function hasClass(targetNode) {
    for (let i = 0; i < targetNode.length; i++) {
        if (targetNode[i].classList.contains("mega-toggle-on")) {
            return true
        }
    }
    return false
}

/**
    * Toggle the site overlay when a menu item is selected.
    *
    */
export function siteDimmer() {
    const dimmer = document.querySelector("#site-dimmer")
    const menus = document.querySelectorAll("#mega-menu-primary-menu > li.mega-menu-item, #mega-menu-igh-menu > li.mega-menu-item")

    const config = { attributes: true, attributeFilter: ['class'] }

    const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type == 'attributes' && mutation.attributeName == 'class') {
                if (hasClass(menus)) {
                    dimmer.classList.add("dimmer")
                } else {
                    dimmer.classList.remove("dimmer")
                }
            }
        }
    }

    menus.forEach((menu) => {
        const observer = new MutationObserver(callback)
        observer.observe(menu, config)
    })
}

export function hideArrows() {
    const mobileMenu = document.querySelector("#ig-main-site-mobile-header #mega-menu-igh-menu");
    if (mobileMenu) {
        const items = mobileMenu.querySelectorAll(".mega-hide-arrow");
        if (items.length > 0) {
            items.forEach((item) => {
                item.classList.add("ig-link");
            });
        }
    }
}
